import type {components} from '@/lib/api-schema'
import {tope} from '@/lib/campos-texto'

export type TipoDocumento = components['schemas']['TipoDocumento']

/** Para los canales que buscan un documento sin pedir su tipo (recuperar contraseña, soporte). */
export const CUALQUIER_DOCUMENTO = 'CUALQUIERA'

export const TIPOS_DOCUMENTO: readonly TipoDocumento[] = ['CC', 'CE', 'PA']

/** Espeja `backend/app/core/documento.py::documento_corto`. */
export function documentoCorto(tipo: TipoDocumento | undefined, numero: string): string {
  return `${tipo ?? 'CC'} ${numero}`
}

/** Espeja los topes de `core/documento.py`; salen de `campos-texto.ts`, nunca escritos a mano. */
export const DOCUMENTO_MAX: Record<TipoDocumento, number> = {
  CC: tope('CEDULA'),
  CE: tope('CEDULA'),
  PA: tope('DOC'),
}

/** Espeja la normalización de `core/documento.py`: «ab-123456» y «AB123456» son una persona. */
export function documentoNormalizado(tipo: TipoDocumento, raw: string): string {
  return tipo === 'PA' ? raw.replace(/[^A-Za-z0-9]/g, '').toUpperCase() : raw.replace(/\D/g, '')
}
